import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import type LessonInfoService from 'teacher-ui-client/services/lesson-info'

export default class FastPhonicsReportingRoute extends Route {
  @service lessonInfo!: LessonInfoService

  async beforeModel() {
    const precincts = [Precinct.FP_PEAKS]

    await this.lessonInfo.loadLessonInfoFor(precincts)
  }

  model() {
    return {
      product: 'fast-phonics',
    }
  }
}
